import { Divider } from "antd";
import { Palette } from "config/palette";
import styled from "styled-components";

export const OpenButtonMenu = styled.div`
    color: ${Palette.White};
    font-size: 28px;
    cursor: pointer;
    padding: 0 10px;
    transition: color 0.2s;

    &:hover {
        color: ${Palette.HeroGreen};
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
    gap: 6px;
`;

export const AppLink = styled.button`
    background: none;
    border: none;
    padding: 2px 0;
    font-family: "AeviFont", sans-serif;
    font-size: 11pt;
    color: ${Palette.AeviBlack};
    cursor: pointer;
    transition: color 0.2s;
    text-align: left;

    &:hover {
        color: ${Palette.HeroGreen};
    }
`;

export const AppDivider = styled(Divider)`
    margin: 4px 0;
`;
